import {NgModule} from '@angular/core';
import {SearchMetaTagsService} from '../services/search-meta-tags.service';
import {SearchRedirectsService} from '../services/search-redirects.service';

@NgModule({
  providers: [SearchMetaTagsService, SearchRedirectsService],
  exports: [],
})
export class SharedSerpModule {}
